import { TenantsType } from '@/consts/setupApp/tenants'
import {
  CASANUESTRA_DEV,
  CASANUESTRA_STG,
  CASANUESTRA,
  CBANK,
  HSP_DEV,
  HSP_STG,
  HSP,
  LOCAL_CBANK,
  MAF_DEV,
  MAF_STG,
  MAF_UAT,
  MAF,
  SUPV_DEV,
  SUPV_SME_DEV,
  SUPV_STG,
  SUPV,
  SUPV_SME_STG,
  SUPV_SME
} from '@/consts/tenants'

export const mappTenant: Record<string, TenantsType> = {
  [CASANUESTRA_DEV]: CASANUESTRA,
  [CASANUESTRA_STG]: CASANUESTRA,
  [HSP_DEV]: HSP,
  [HSP_STG]: HSP,
  [LOCAL_CBANK]: CBANK,
  [MAF_DEV]: MAF,
  [MAF_STG]: MAF,
  [MAF_UAT]: MAF,
  [SUPV_DEV]: SUPV,
  [SUPV_STG]: SUPV,
  [SUPV_SME]: SUPV_SME,
  [SUPV_SME_DEV]: SUPV_SME,
  [SUPV_SME_STG]: SUPV_SME
}
